import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Table, Icon, Input, Modal, Popup} from 'semantic-ui-react';
import {validateCheckedQuantity, validatePartPrice, checkRequiredField, getTotalValue} from './utils';
import {toInteger, toUpperCase} from '../../../../common/util/fieldsNormalization';
import {setErrorMessage} from '../../../../common/components/form/common/index';
import {tabKeyCode, enterKeyCode} from '../../../../common/constants/keyCodes';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import {stopEvent} from '../../../../common/util/event';
import {Actions} from '../../../../common/actions';

class ManualTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'partCodeWasChecked': false,
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidUpdate() {
    const {partCodeWasChecked} = this.state;
    const {currentItem} = this.props;

    if (!this.props.items[currentItem]) {
      return;
    }
    const itemWasSaved = this.props.items[currentItem].itemSaved;
    if (this.props.items[currentItem].partCodeCkecked && !partCodeWasChecked && !itemWasSaved) {
      this.setState({'partCodeWasChecked': true}, () => {
        const element = document.getElementsByName(`items[${currentItem}].quantity`)[0];
        element.focus();
      });
    }
  }

  verifyLineInfo(item, index, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    this.setState({'partCodeWasChecked': false});
    const partCode = event.target.value;
    if (!partCode) {
      return;
    }
    this.props.verifyStockInWarehouse(this.props.warehouse, partCode, index);
  }

  verifyLineInfoInOnBlurEvent(item, index, event) {
    const partCode = event.target.value;
    if (!partCode) {
      return;
    }
    this.setState({'partCodeWasChecked': false});
    this.props.verifyStockInWarehouse(this.props.warehouse, partCode, index);
  }

  onPartCodeInputFocus(index) {
    this.props.setCurrentItemIndex(index);
  }

  handleKeyDown(index, {element, fields}, event) {
    const {isPriceEditionEnabled} = this.props;
    if (!isPriceEditionEnabled) {
      return this.addItemToOrder(index, {element, fields}, event);
    }
  }

  addItemToOrder(index, {element, fields}, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    const isInvalidQuantity = validateCheckedQuantity(element.quantity, element.availableStock);
    const isInvalidPrice = validatePartPrice(element);
    if (isInvalidQuantity || isInvalidPrice) {
      this.props.addMessageBoxError(isInvalidPrice || isInvalidQuantity);
      return;
    }

    const data = {
      'clientRuc': this.props.client,
      'agency': this.props.agency,
      'warehouse': this.props.warehouse,
      'partCode': element.partCode,
      'quantity': element.quantity,
      'price': parseFloat(element.price),
    };
    this.props.addItemToManualOrder(index, data);
  }

  updatePartPrice(index, event) {
    const price = event.target.value;
    this.updateSubtotal(index, null, price);
  }

  updateQuantity(index, event) {
    const quantity = event.target.value;
    this.updateSubtotal(index, quantity, null);
  }

  updateSubtotal(index, quantity, price) {
    this.props.updateSubtotal(index, quantity, price);
  }
  
  onDeleteItemClick(index, partCode) {
    const {client, agency, warehouse} = this.props;
    const data = {
      'clientRuc': client,
      agency,
      warehouse,
      partCode,
    };
    this.props.deleteItemFromManualOrder(index, data);
  }

  renderTotalValues(allItems) {
    const subTotal = getTotalValue(allItems, 'subTotal');
    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='left' colSpan={2}>
          <span>TOTAL</span>
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <span>{_.sumBy(allItems, 'quantity')}</span>
        </Table.Cell>
        <Table.Cell textAlign='center'>
        </Table.Cell>
        <Table.Cell textAlign='right'>
        </Table.Cell>
        <Table.Cell textAlign='right'>
          <span className='totals-row'>{'$'}{getNumericValue(subTotal, 2)}</span>
        </Table.Cell>
        <Table.Cell textAlign='center'>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderDeleteButton(index, itemSaved, partCode) {
    if (!itemSaved) {
      return null;
    }
    return (
      <Modal size='mini'
        trigger={
          <span className='link'>
            <Popup
              trigger={
                <span>
                  <Icon link name='delete' color='blue' size='large' />
                </span>
              }
              content="Eliminar"
              position='top center'
              inverted
            />
          </span>
        }
        header='¿Está seguro que desea eliminar el item seleccionado?'
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Confirmar', 'positive': true,
            'onClick': () => this.onDeleteItemClick(index, partCode),
            'primary': true,
          },
        ]}
      />
    );
  }
  
  renderPartPrice(fields, item, index) {
    const {savingLineInfo, isPriceEditionEnabled} = this.props;
    const element = fields.get(index);

    if (!element.price && !isPriceEditionEnabled) {
      return ('$0');
    } else if (element.itemSaved || !isPriceEditionEnabled) {
      return (`$${element.price}`);
    }

    return (
      <Field
        name={`${item}.price`}
        type="number"
        min='0' step='0.01'
        component={Input}
        required
        autoComplete='off'
        disabled={element.itemSaved || !element.partCodeCkecked || !element.partCode || savingLineInfo}
        validate={checkRequiredField}
        onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
        onInput={(event) => setErrorMessage('', event)}
        onKeyDown={this.addItemToOrder.bind(this, index, {element, fields})}
        onChange={this.updatePartPrice.bind(this, index)}
      />
    );
  }

  renderRowPartCodeValue({item, element, index, savingLineInfo}) {
    if (element.itemSaved) {
      return element.partCode;
    }

    return (
      <Field
        name={`${item}.partCode`}
        type="text"
        component={Input}
        required
        autoComplete='off'
        autoFocus
        disabled={element.itemSaved || savingLineInfo}
        validate={checkRequiredField}
        onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
        onInput={(event) => setErrorMessage('', event)}
        normalize={toUpperCase}
        onKeyDown={this.verifyLineInfo.bind(this, element, index)}
        onBlur={this.verifyLineInfoInOnBlurEvent.bind(this, element, index)}
        onFocus={this.onPartCodeInputFocus.bind(this, index)}
        placeholder="Código de Parte"
      />
    );
  }

  renderRowCheckedQuantity({fields, item, element, index, savingLineInfo}) {
    if (element.itemSaved) {
      return element.quantity;
    }

    return (
      <Field
        name={`${item}.quantity`}
        type="number"
        component={Input}
        required
        autoComplete='off'
        validate={checkRequiredField}
        normalize={toInteger}
        disabled={element.itemSaved || !element.partCodeCkecked || !element.partCode || savingLineInfo}
        min='1' step='1' max='9999999999'
        onInvalid={(event) => setErrorMessage('Por favor, llene este campo solo con enteros mayores a cero', event)}
        onInput={(event) => setErrorMessage('', event)}
        onKeyDown={this.handleKeyDown.bind(this, index, {element, fields})}
        onChange={this.updateQuantity.bind(this, index)}
        placeholder="Cantidad Requerida"
      />);
  }

  renderItems(fields) {
    const {savingLineInfo} = this.props;
    
    return fields.map((item, index) => {
      const element = fields.get(index);
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            {this.renderRowPartCodeValue({item, element, index, savingLineInfo})}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderRowCheckedQuantity({fields, item, element, index, savingLineInfo})}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.availableStock}</Table.Cell>
          <Table.Cell textAlign='right'>
            {this.renderPartPrice(fields, item, index)}
          </Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{element.subTotal || 0}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderDeleteButton(index, element.itemSaved, element.partCode)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {fields, allItems} = this.props;

    return (
      <Table.Body>
        {this.renderItems(fields)}
        {this.renderTotalValues(allItems)}
      </Table.Body>
    );
  }
}

const {
  verifyStockInWarehouse,
  updateSubtotal,
  addMessageBoxError,
  addItemToManualOrder,
  deleteItemFromManualOrder,
} = Actions;

export default connect(null, {
  verifyStockInWarehouse,
  updateSubtotal,
  addMessageBoxError,
  addItemToManualOrder,
  deleteItemFromManualOrder,
})(ManualTable);
